import { MonetaryAmount } from '@/common/monetary/MonetaryAmount';
import { isoCurrencyMinorUnits } from '@/common/monetary/isoCurrencyMinorUnits';
import type { FundingSource } from '@/integrations/Immersve/funding-sources/types';

// Stablecoins such as USDC aren't ISO currencies, so their balance shows in
// minor units rather than guessing at their decimals.
export function balanceLabel(fundingSource: FundingSource): string {
  return MonetaryAmount.fromPaymentAmount({
    value: fundingSource.balance,
    currency: fundingSource.balanceCurrency,
  }).format();
}

// Lets a headline set "minor units" apart from the figure, rather than in it.
export function isInMinorUnits(fundingSource: FundingSource): boolean {
  return isoCurrencyMinorUnits[fundingSource.balanceCurrency] === undefined;
}
